<template>
  <div class="card shadow">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-6">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'products' }">Products</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Edit Product
              </li>
            </ol>
          </nav>
        </div>
        <div class="col-6 text-right">
          <el-button v-if="product.featured" size="mini" type="primary" @click="onFeature">Featured</el-button>
          <el-button v-else size="mini" @click="onFeature">Feature</el-button>
        </div>
      </div>
    </div>
    <div class="card-body" v-loading="loading">
      <el-tabs v-model="activePane" @tab-click="tabChange">
        <el-tab-pane label="Details" name="details">
          <product-item-detail v-if="product" :product="product" />
        </el-tab-pane>
        <el-tab-pane label="Images" name="images">
          <product-item-image v-if="product" :product="product" />
        </el-tab-pane>
        <el-tab-pane label="Features" name="features">
          <product-item-feature v-if="product" :product="product" />
        </el-tab-pane>
        <el-tab-pane label="Variants" name="variants">
          <product-item-variant v-if="product" :product="product" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ProductItemDetail from '@/components/Product/Item/ProductItemDetail'
import ProductItemImage from '@/components/Product/Item/ProductItemImage'
import ProductItemFeature from '@/components/Product/Item/ProductItemFeature'
import ProductItemVariant from '@/components/Product/Item/ProductItemVariant'

export default {
  components: {
    ProductItemDetail,
    ProductItemImage,
    ProductItemFeature,
    ProductItemVariant,
  },

  data() {
    return {
      loading: false,
      activePane: 'details',
      product: null,
    }
  },

  async mounted() {
    this.getProduct()
  },

  methods: {
    async getProduct() {
      this.loading = true

      try {
        var { data } = await this.$http.get(`/products/${ this.$route.params.id }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.product = data
    },

    async onFeature() {
      try {
        var { data } = await this.$http.put(`/products/${ this.$route.params.id }`, {
          featured: !this.product.featured,
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }

      this.getProduct()
    },

    tabChange(tab, event) {
      this.activePane = tab.name
    },
  }
}
</script>
